<template>
  <div>
     <el-dialog
      title=''
      class="detail-dialog"
      :visible.sync="dialogVisible"
      width="800px"
      :modal="modal"
      top="10vh"
    >
      <div class="detail-dialog-header">
        <div class="title">{{title}}</div>
        <div class="row dialog-date-source">
          <div class="row">
            <div>{{date}}</div>
            <div class="source">{{source}}</div>
          </div>
          <div class="row">
            <el-switch inactive-color="#d1d2da" v-model="switchStatus"></el-switch>
            <div class="switch-title">线索高亮</div>
          </div>
        </div>
      </div>
      <div class="detail-dialog-content content" :class="{'detail-dialog-content-highlight': !switchStatus}">
        <div v-html="detail"></div>
      </div>
      <div class="detail-dialog-footer">
        <a class="url" :href="this.url" target="_blank">查看原文</a>
        <div class="warning">注意：点击"查看原文"将跳转至第三方源网站，可能存在原文地址失效无法访问的情况。</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QuestionQuery from '@/rest/questionQuery';
import Mark from 'mark.js';

export default {
  data() {
    return {
      dialogVisible: false,
      title: '',
      date: '',
      source: '',
      detail: '',
      url: '',
      instance: '',
      negativeHeight: [],
      positiveHeight: [],
      switchStatus: true
    };
  },
  props: {
    modal: {
      default: true
    }
  },
  methods: {
    checkDetail(id) {
      QuestionQuery.getNewsDetail(id).then(res => {
        const a = document.createElement('a');
        a.setAttribute('href', res.url);
        a.setAttribute('target', '_blank');
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      });
    }
  },
  updated() {
    const instance = new Mark(document.querySelectorAll('.detail-dialog-content'));
    instance.mark(this.positiveHeight || [], {
      element: 'span',
      className: 'positive-height'
    });
    instance.mark(this.negativeHeight || [], {
      element: 'span',
      className: 'negative-height'
    });
  }
};
</script>

<style lang="scss" scoped>
  /deep/.detail-dialog {
  .detail-dialog-header {
    padding: 32px 32px 26px;
    min-height: 114px;
    width: 100%;
    background-color: #f7f8fc;
    .title {
      margin-bottom: 12px;
      color: #171f46;
      font-size: 20px;
      font-weight: 500;
    }
    .dialog-date-source {
      line-height: 20px;
      justify-content: space-between;
      color: #747990;
      font-size: 12px;
      font-weight: 500;
      .source {
        margin-left: 16px;
      }
      .switch-title {
        margin-left: 8px;
        color: #464d6c;
      }
    }
  }
  .detail-dialog-content {
    padding: 24px 32px;
    height: 496px;
    overflow: auto;
    color: #464d6c;
    font-size:14px;
    line-height: 22px;
    background-color: #ffffff !important;
  }
  .detail-dialog-content-highlight span.positive-height{
    color: #464d6c !important;
  }
  .detail-dialog-content-highlight span.negative-height{
    color: #464d6c !important;
  }
  .detail-dialog-footer {
    padding: 16px 32px;
    background-color: #f7f8fc;
    .url {
      color: #45a8cc;
      font-size: 14px;
      font-weight: 500;
      text-decoration: none;
    }
    .warning {
      margin-top: 4px;
      color: #747990;
      font-size: 12px;
    }
  }
  .el-dialog {
    background-color: #ffffff;
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      min-height: 680px;
      padding: 0;
    }
    .el-dialog__footer {
      padding: 0px;
    }
  }
}
/deep/{
  .el-switch__core {
    width: 34px !important;
  }
  .el-switch__core:after {
    top: 3px;
    left: 3px;
    width: 12px;
    height: 12px;
    background-color: #e4e4e4;
  }
  .el-switch.is-checked .el-switch__core::after {
    margin-left: -14px;
  }
}
</style>
<style lang="css">
.detail-dialog-content.content a {
  color: #45a8cc !important;
}
.detail-dialog-content.content a span {
  color: #45a8cc !important;
}
.detail-dialog-content.content img {
  max-width: 100% !important;
}
.detail-dialog-content.content video {
  max-width: 100% !important;
}
</style>
